/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import {
    TextField,
    Button,
    DialogActions,
    DialogContent,
    Grid,
    Paper,
    Typography
} from 'material-ui';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';

import { getUserInformation } from '../../Login/loginService';
import { updateReservationObservations } from '../../Reservations/reservationsServices';
import { translate } from 'react-i18next';
import ObservationsChecksRender from '../ObservationsChecksRender';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '16px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
    }
});

/**
 * Componente encargado de la edicion de huespedes y habitaciones.
 * Maneja una copia del rooms original. Si cancela no devuelve el rooms, Si Acepta devuelve el rooms actualizado.
 *
 * @author Luciano Bustos
 *
 */
class ReservationObservationsDialog extends React.Component {
    constructor(props) {
        super(props);

        this.currentUser = getUserInformation();
        this.state = {
            observations: props.data,
            observationsChecks: props.checks,
            success: false,
            loading: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ observations: nextProps.data, success: false, loading: false });
    }

    updateObservations = async () => {
        try {
            const observations = { 'observationData': this.getObservations() };
            const obs = this.getObservations();
            if (obs && obs.length) {
                localStorage.setItem('updatedObservations', JSON.stringify(obs[0].value));
            }
            let result = await updateReservationObservations(
                this.props.reservationId, observations);
            return result;
        } catch (error) {
            this.setState({
                success: false,
                loading: false
            });
        }
    }

    getObservations() {
        const { observations, observationsChecks } = this.state;
        const { t } = this.props;
        let observationsChecked = observationsChecks.filter(check => !!check.checked);
        let obs = [];
        if (observationsChecked && observationsChecked.length) {
            obs = observationsChecked.map(checks => (
                { id: checks.value, value: t(checks.label) }
            ));
            obs.unshift({ id: 1, value: observations ? observations : '' });
            return obs;
        } else {
            obs.unshift({ id: 1, value: observations ? observations : '' });
            return obs;
        }
    }

    handleClose = () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true });
        }
        this.updateObservations().then(result => {
            this.setState({ success: true, loading: false });
            this.props.onClose(this.state.observations);
        });
    };

    handleCancel = () => {
        this.props.onClose(this.props.data);
    };

    handleObsChange = (value) => {
        this.setState({ observations: value });
        this.props.onChangeObservation(value);
    }

    formatObservations = (observations) => {
        let obs = Array.isArray(observations) ? observations.join('\n') : observations.replace(/\\r\\n/, '\n');
        return obs;
    }

    render() {
        const { classes, onClose, data, t, ...other } = this.props;
        const { loading, success } = this.state;

        const buttonClassname = classNames({
            [classes.buttonSuccess]: success
        });
        let observations = data ? data : '';
        return (
            <Dialog
                onClose={this.handleCancel}
                onEnter={this.handleEnter}
                aria-labelledby="simple-dialog-title"
                fullWidth={true}
                maxWidth="md"
                {...other}
            >
                <DialogTitle disableTypography={true} id="simple-dialog-title" className={classes.dialogTitle}>
                    {t('MODIFY_BOOKING.MODIFY_OBSERVATIONS')}
                </DialogTitle>
                <DialogContent className="dialog-observations">
                    <ObservationsChecksRender {...this.props} />
                    <Paper style={{ minWidth: '480px', padding: '12px' }} elevation={0}>
                        <Grid item xs={12}>
                            <TextField
                                className="dialog-input-observations"
                                defaultValue={this.formatObservations(observations)}
                                multiline={true}
                                rows="4"
                                margin="normal"
                                fullWidth={true}
                                autofocus={true}
                                onChange={event => this.handleObsChange(event.target.value)}>
                            </TextField>
                        </Grid>
                    </Paper>
                    <Typography>
                        {t('CONFIRM_BOOKING.SPECIAL_REQUESTS')}
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.root + ' popup-observations'} style={{ padding: '12px' }}>
                    <div className={classes.wrapper + ' popup-observations-cancel'}>
                        <Button
                            disabled={loading}
                            onClick={this.handleCancel}>
                            {t('CANCEL_BOOKING.CANCEL')}
                        </Button>
                    </div>
                    <div className={classes.wrapper}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={buttonClassname}
                            disabled={loading}
                            onClick={this.handleClose}
                        >
                            {t('COMMON.SAVE')}
                        </Button>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

ReservationObservationsDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(ReservationObservationsDialog));



// WEBPACK FOOTER //
// ./src/components/Reservation/Modification/ReservationObservationsDialog.js